import fetch from "@/fetch";

// 获取E-chart图表数据
export const getUserBaseData = params => {
  return fetch({
    method: "post",
    url: "/focus/motion/userCenterDetail/getUserBaseInfo",
    data: params
  });
};

//标签更新-删除
export const updataTag = params => {
  return fetch({
    method: "post",
    url: "/focus/motion/userCenterDetail/updateUserTags",
    data: params
  });
};

//获取用户浏览记录
export const getUserTopView = params => {
  return fetch({
    method: "post",
    url: "/focus/motion/userCenterDetail/getTopViewProduct",
    data: params
  });
};
